import type {IdentityVerificationSchema} from '../identityVerification';

export const getDocumentType = (state: IdentityVerificationSchema) =>
  state.setupFormDate.documentType;
